import { render, staticRenderFns } from "./CustPotential.vue?vue&type=template&id=b04c21e4&scoped=true"
import script from "./CustPotential.vue?vue&type=script&lang=js"
export * from "./CustPotential.vue?vue&type=script&lang=js"
import style0 from "./CustPotential.vue?vue&type=style&index=0&id=b04c21e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b04c21e4",
  null
  
)

export default component.exports